export class LocationMatch {
    locationName: string;
    locationId: number;
    postalCode: string;
    isMatched: boolean;
    canEdit: boolean;
}
